import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgBodyStomach = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M6.375 21.375V20.125C6.375 19.7935 6.5067 19.4755 6.74112 19.2411C6.97554 19.0067 7.29348 18.875 7.625 18.875C8.25 18.875 8.25 21.375 13.875 21.375C19.5 21.375 21.375 16.375 21.375 13.875C21.375 8.25 17.625 5.125 12.625 5.125C12.2935 5.125 11.9755 4.9933 11.7411 4.75888C11.5067 4.52446 11.375 4.20652 11.375 3.875V2.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.625 21.375V20.125C2.67603 18.8152 3.2192 17.5729 4.14605 16.646C5.0729 15.7192 6.31523 15.176 7.625 15.125C8.88 15.125 12.6575 11.9733 10.7258 7.56833"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.625 2.625V3.875C7.6261 4.86922 8.02154 5.82241 8.72457 6.52543C9.42759 7.22845 10.3808 7.6239 11.375 7.625H12.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgBodyStomach.displayName = 'SvgBodyStomach';
export default SvgBodyStomach;
